import styled from 'styled-components';
import { Container } from 'components/Header/styled';


export const Main = styled.main``;

export const MainContainer = styled(Container)`
`;